module.exports = __webpack_public_path__ + "img/acc2.098814cd.png";